export enum EventsEnum {
  SEND_EVALUATION = 'SEND_EVALUATION',
  SUBMIT_SHORT_FORM = 'SUBMIT_SHORT_FORM',
}
